import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@/api/constants";

import { apiLocations } from "./apiLocations";
import type { LocationData } from "./types";

export const useGetLocationDataIdQuery = (
  id: string,
  enabled: boolean = true
) => {
  return useQuery<LocationData>({
    queryKey: [QUERY_KEYS.locationData, id],
    queryFn: () => apiLocations.getAddressOptionsById(id),
    enabled: !!id && enabled,
  });
};
